import { render, staticRenderFns } from "./AppointmentSelection.vue?vue&type=template&id=12cac4bf&scoped=true&"
import script from "./AppointmentSelection.ts?vue&type=script&lang=ts&"
export * from "./AppointmentSelection.ts?vue&type=script&lang=ts&"
import style0 from "./AppointmentSelection.scss?vue&type=style&index=0&id=12cac4bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cac4bf",
  null
  
)

export default component.exports